import { Outlet } from 'react-router-dom';
import SideNav from '../SideNav/SideNav';
import styles from './AppLayout.module.css';

export default function AppLayout({ user, onLogout }) {
  return (
    <div className={styles.shell}>
      <SideNav user={user} onLogout={onLogout} />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
